import { Button } from '../ui/Button';
import { DS_TABS, type DSTabDefinition } from './dsTabsConfig';

interface DesignSystemTabsProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export const DesignSystemTabs: React.FC<DesignSystemTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-neutral-200 pb-4">
      {DS_TABS.map((tab: DSTabDefinition) => (
        <Button
          key={tab.id}
          variant={activeTab === tab.id ? 'primary' : 'ghost'}
          size="sm"
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </Button>
      ))}
    </div>
  );
};
